import { NavLink, Outlet, useNavigate } from "react-router-dom";
import {
  LayoutDashboard,
  Package,
  ShoppingCart,
  Users,
  LineChart,
  Store,
  LogOut,
  Bike,
  Settings,
  MapPin,
  Handshake,
  Ticket,
  Boxes,
  Receipt,
  Wallet,
  ClipboardList,
  MessageSquare,
  Bell,
} from "lucide-react";
import { useAuth } from "../contexts/AuthContext";
import { NotificationBell } from "./NotificationBell";

const LINKS = [
  { to: "/admin", end: true, icon: LayoutDashboard, label: "Overview" },
  { to: "/admin/orders", icon: ShoppingCart, label: "Orders" },
  { to: "/admin/products", icon: Package, label: "Products" },
  { to: "/admin/categories", icon: Boxes, label: "Categories" },
  { to: "/admin/notifications", icon: Bell, label: "Notifications" },
  { to: "/admin/customers", icon: Users, label: "Customers" },
  { to: "/admin/analytics", icon: LineChart, label: "Analytics" },
  { to: "/admin/delivery-boys", icon: Bike, label: "Delivery Boys" },
  { to: "/admin/reconciliation", icon: Wallet, label: "Rider Cash" },
  { to: "/admin/partner-stores", icon: Handshake, label: "Partner Stores" },
  { to: "/admin/store-inventory", icon: Boxes, label: "Store Inventory" },
  { to: "/admin/coupons", icon: Ticket, label: "Coupons" },
  { to: "/admin/settlements", icon: Receipt, label: "Settlements" },
  { to: "/admin/areas", icon: MapPin, label: "Service Areas" },
  { to: "/admin/unserviceable-leads", icon: MessageSquare, label: "Missed Leads" },
  { to: "/admin/storefront", icon: Store, label: "Storefront" },
  { to: "/admin/settings", icon: Settings, label: "Settings" },
  { to: "/admin/audit-logs", icon: ClipboardList, label: "Audit Logs" },
];

export function AdminLayout() {
  const { user, logout } = useAuth();
  const nav = useNavigate();
  return (
    <div className="admin-scope min-h-screen">
      <div className="flex">
        <aside className="hidden md:flex sticky top-0 h-screen w-64 flex-col border-r border-zinc-800 bg-neutral-950 p-4">
          <div className="flex items-center gap-2 border-b border-zinc-800 pb-4">
            <div className="grid h-9 w-9 place-items-center rounded-md bg-orange-600 text-white font-display font-bold">
              Q
            </div>
            <div>
              <p className="text-sm font-bold tracking-tight">Quick Door Now</p>
              <p className="text-[10px] uppercase tracking-widest text-zinc-500">Admin Console</p>
            </div>
          </div>
          <nav className="mt-4 flex-1 space-y-0.5">
            {LINKS.map((l) => {
              const Icon = l.icon;
              return (
                <NavLink
                  key={l.to}
                  to={l.to}
                  end={l.end}
                  data-testid={`admin-nav-${l.label.toLowerCase().replace(" ", "-")}`}
                  className={({ isActive }) =>
                    `flex items-center gap-3 rounded-md px-3 py-2 text-sm ${
                      isActive
                        ? "bg-zinc-900 text-white border border-zinc-800"
                        : "text-zinc-400 hover:bg-zinc-900 hover:text-white"
                    }`
                  }
                >
                  <Icon size={16} strokeWidth={1.5} />
                  {l.label}
                </NavLink>
              );
            })}
          </nav>
          <div className="border-t border-zinc-800 pt-3">
            <p className="text-xs text-zinc-500 truncate">{user?.email}</p>
            <div className="mt-2 flex gap-2">
              <button
                onClick={() => nav("/")}
                className="flex items-center gap-1 rounded-md border border-zinc-800 px-2 py-1 text-xs text-zinc-300 hover:bg-zinc-900"
              >
                <Store size={12} /> Storefront
              </button>
              <button
                data-testid="admin-logout"
                onClick={() => {
                  logout();
                  nav("/");
                }}
                className="flex items-center gap-1 rounded-md border border-zinc-800 px-2 py-1 text-xs text-zinc-300 hover:bg-zinc-900"
              >
                <LogOut size={12} /> Logout
              </button>
            </div>
          </div>
        </aside>
        <main className="flex-1 p-4 md:p-8 min-w-0">
          <div className="mb-4 flex items-center justify-between">
            <div className="text-xs text-zinc-500 font-mono">Admin · Live</div>
            <NotificationBell />
          </div>
          <Outlet />
        </main>
      </div>
    </div>
  );
}
